<template lang="pug">
div
  div(:class='{ "px-3": isMobileForm }')
    PageTitle
    ExportCsv(ref='exportCsv' :forms='unsafeSortedFilteredForms' :formGroupId='formGroupId' :headers='headers' :isFiltered='isSearching || isFiltering' @resetSearchAndFilter='resetSearchAndFilter')
    AdvanceForm(ref='advanceForm' :forms='forms' :formGroupId='formGroupId' :headers='headers' :period='period' @success='successEdit')
    //- 載入失敗訊息
    v-alert(type='error' :value='true' v-if='forms === false' icon='warning') {{ $t('errorWhileLoading') }} {{ error }}

    //- 麵包屑
    FormBreadcrumb

  //- 組別選單
  v-tabs(slider-color='primary' v-model='selectedTab' show-arrows)
    v-tab(:disabled='isLoading') All
    v-divider(vertical)
    v-tab(v-for='(i, index) in groupList' :key='index' :disabled='isLoading') {{ convertGroupText(i) }}

  //- 報名表單 Table
  v-card
    v-card-title
      .title {{ (formGroupId !== -1) ? convertGroupText(formGroupId) : `ALL` }}
      v-tooltip(bottom)
        v-btn(slot='activator' flat icon color='primary' @click='refresh' :loading='isLoading' v-if='forms !== false'): v-icon refresh
        span 重新整理

      v-divider.mx-2(vertical)
      v-btn(small flat :icon='isMobile' color='primary' @click='clickCsv' :disabled='isLoading')
        v-icon(:left='!isMobile' small) fas fa-table
        span(v-if='!isMobile') 匯出 CSV...
      v-btn(small flat :icon='isMobile' color='primary' @click='clickAdvance' :disabled='isLoading')
        v-icon(:left='!isMobile' small) fas fa-level-up-alt
        span(v-if='!isMobile') 晉級表單...
      DebugCodeBlock(:value='pagination' :beautify='false')
      v-spacer

      //- 搜尋功能
      FormSearch(v-model='search' :forms='forms' :headers='headers')
        template(v-slot:append-outer)
          v-menu(bottom right offset-y :close-on-content-click='false')
            v-icon(small slot='activator' :color='filter.status.some(v => !v.value) ? `primary` : ``') fas fa-filter
            v-list(subheader)
              v-subheader 依表單狀態篩選
              v-list-tile(@click='filter.status[index].value = !filter.status[index].value' v-for='(i, index) in filter.status' :key='index')
                v-list-tile-action: v-icon(:color='i.value ? `primary` : ``') {{ i.value ? `fa fa-check-square` : `far fa-square` }}
                v-list-tile-title {{ convertFormStatusObject(i.key).name }}
              v-divider
              v-list-tile(@click='resetFilter')
                v-list-tile-action: v-icon fas fa-redo-alt
                v-list-tile-title 重設

    //- 搜尋/篩選結果數量提示
    v-fade-transition(hide-on-leave)
      v-alert(:value='true' type='info' icon='search' v-if='isSearching || isFiltering')
        span 總共有 #[b {{ length }}] 項結果
        v-btn.mr-4.my-0(depressed small flat dark @click='resetSearchAndFilter') 重設搜尋/篩選

    VDataTable(
      ref='table'
      :headers='headers'
      :items='filteredForms'
      :pagination.sync='pagination'
      rows-per-page-text='每頁筆數'
      :rows-per-page-items='[10, 25, 50, { "text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1 } ]'
      item-key='id'
      :loading='isLoading'
      :class='{ mobile: isMobile, tablet: isTablet }'
      :hide-headers='isMobile'
      :expand='isMobile'
      must-sort
    )
      v-progress-linear(slot='progress' color='primary' indeterminate)
      template(slot='items' slot-scope='props')
        tr(@click="props.expanded = !props.expanded")
          //- 組別 (group)
          td.text-no-wrap
            .caption.grey--text(v-if='isMobile') {{ getHeaderText('group') }}
            | {{ convertGroupText(props.item.group) }}
          //- 報名人 (name/school)
          td.no-wrap(:title='`${props.item.name} / ${props.item.school || "社會組"}`')
            .caption.grey--text(v-if='isMobile') {{ getHeaderText('name') }}
            span
              CopyableText {{ props.item.name }}
              span.grey--text.mx-1 -
              CopyableText(v-if='props.item.school') {{ props.item.school }}
              em(v-else) 社會組
          //- 歌曲 (song)
          td(:style='!isMobile ? `min-width: 150px` : ``' :title='props.item.song')
            .caption.grey--text(v-if='isMobile') {{ getHeaderText('song') }}
            CopyableText {{ props.item.song }}
          //- 報名時間 (timestamp)
          td
            .caption.grey--text(v-if='isMobile') {{ getHeaderText('timestamp') }}
            span {{ props.item.timestamp | time }}
          //- Email (email)
          td
            .caption.grey--text(v-if='isMobile') {{ getHeaderText('email') }}
            CopyableText {{ props.item.email }}
          //- 電話 (phone)
          td
            .caption.grey--text(v-if='isMobile') {{ getHeaderText('phone') }}
            CopyableText(:value='props.item.phone')
              PhoneNumberText(:value='props.item.phone')
          td(:class='convertFormStatusObject(+props.item.status).class')
            .caption.grey--text(v-if='isMobile') {{ getHeaderText('status') }}
            span {{ convertFormStatusObject(props.item.status).name }}
          td.buttons
            EditComment(:period='period' :id='props.item.id' :isComment='!!props.item.comment' @success='successEdit')
            v-tooltip(bottom)
              v-btn.mx-0(slot='activator' icon flat @click.stop='clickEditForm(props.item.id)')
                 v-icon(small) edit
              span 編輯報名表單

      //- 點擊項目後展開的內容
      template(slot='expand' slot-scope='props')
        v-card(flat)
          v-card-text
            v-layout(row wrap)
              v-flex.id(xs12 v-if='isDebugMode'): .caption.pl-1.mt-2.grey--text [ID] {{ props.item.id }}

              v-flex(xs6 md4 v-if='props.item.equipment')
                //- 團員
                v-subheader.pl-1 團員
                .pl-2(v-if='!props.item.partners || !props.item.partners.length > 0') -
                v-chip(v-for='(i, index) in props.item.partners' :key='index')
                  v-avatar.pink.lighten-3 {{ i[0] }}
                  CopyableText {{ i }}

              //- [設備] 標題&items
              v-flex(xs6 md4)
                v-subheader.pl-1 設備
                .pl-2(v-if='getIsCountableEquipmentEmpty(props.item.equipment)') -
                v-chip(
                  v-for='(name, key) in equipmentTable'
                  v-if='getIsEquipmentCountable(key) && props.item.equipment[key] > 0'
                  :title='`${convertEquipmentText(key)}數量: ${props.item.equipment[key]}`'
                  :key='key'
                )
                  v-avatar.light-blue.darken-4.white--text {{ props.item.equipment[key] }}
                  span.equipment-item {{ convertEquipmentText(key) }}

              //- [效果器、其他] 標題&文字
              v-flex(xs6 md4 :key='key' v-for='key in uncountableEquipmentList')
                v-subheader.pl-1 {{ convertEquipmentText(key) }}
                .pl-2(v-if='props.item.equipment[key]') {{ props.item.equipment[key] }}
                .pl-2(v-else) -

              //- 繳費代碼
              v-flex(xs6 md4)
                v-subheader.pl-1 繳費代碼
                .pl-2(v-if='props.item.code'): CopyableText {{ props.item.code }}
                .pl-2(v-else) -

              //- 評語
              v-flex.comment(xs6 md4)
                v-subheader.pl-1 評語
                v-card(flat v-if='props.item.comment')
                  v-layout.pl-1(row wrap)
                    v-flex.mb-1(xs12 v-if='props.item.comment.score || props.item.comment.score === 0')
                      span.font-weight-light.display-1 {{ props.item.comment.score }}
                      span.font-weight-bold  分
                    v-flex(xs12)
                      p(v-if='props.item.comment.content') {{ props.item.comment.content }}
                      p(v-else): i -
                      template(v-if='props.item.comment.imgBase64')
                        template(v-if='Array.isArray(props.item.comment.imgBase64)')
                          v-dialog(max-width='600' v-for='(i, index) in props.item.comment.imgBase64' :key='index')
                            v-img.mr-1.d-inline-block(:src='i' width='64' height='64' contain position='center center' slot='activator')
                            v-card: img.img-fluid(:src='i')
                        v-img(v-else :src='props.item.comment.imgBase64' height='200' contain position='left top')

                .pl-2(v-else) -

      template(v-slot:no-data): div
  DebugCodeBlock(:value='forms')
  SnackbarSuccess(ref='successSnackbar')
  Snackbar(ref='snackbar')
  EditForm(ref='editForm' :period='period' @success='successEdit')
</template>

<script>
import apis from '@/assets/js/apis'
import { login } from '@/mixins/login'

import Loader from '@/components/Loader.vue'
import SnackbarSuccess from '@/components/SnackbarSuccess.vue'
import Snackbar from '@/components/Snackbar.vue'
import PageTitle from '@/components/PageTitle.vue'
import PhoneNumberText from '@/components/PhoneNumberText.vue'
import CopyableText from '@/components/CopyableText.vue'

import FormBreadcrumb from '@/components/form/FormBreadcrumb.vue'
import FormSearch from '@/components/form/FormSearch.vue'
import EditForm from '@/components/form/EditForm.vue'
import EditComment from '@/components/form/EditComment.vue'
import ExportCsv from '@/components/form/ExportCsv.vue'
import AdvanceForm from '@/components/form/AdvanceForm.vue'
import { filterForms } from '@/modules/filterForms'

export default {
  name: 'Form',
  metaInfo () {
    return {
      title: this.$t('報名表單'),
    }
  },
  data () {
    return {
      headers: [
        { text: '組別', value: 'group' },
        { text: '報名人', value: 'name' },
        { text: '歌曲', value: 'song' },
        { text: '學校', value: 'school', class: 'hidden' },
        { text: '報名時間', value: 'timestamp' },
        { text: 'Email', value: 'email' },
        { text: '電話', value: 'phone' },
        { text: '狀態', value: 'status' },
        { text: '操作', value: '', sortable: false },
      ],
      pagination: {
        sortBy: 'timestamp',
        descending: true,
      },
      selectedTab: 0,
      forms: null,
      search: '',
      error: null,
      isRefetching: false, // 編輯完表單或評論後設為true，表示正在重新fetch Forms
      filter: {
        status: [{ key: 1, value: true }, { key: 2, value: true }, { key: 3, value: true }],
      },
    }
  },
  mounted () {
    this.handleQuery()
    this.fetch()
    if (this.statePreference.formsRowsPerPage) this.pagination.rowsPerPage = this.statePreference.formsRowsPerPage
  },
  methods: {
    async fetch () {
      const params = {}

      const groupId = this.formGroupId
      const period = this.period
      const level = this.level

      if (groupId !== -1) params.group = groupId
      if (period) params.period = period
      if (level) params.level = level

      try {
        this.forms = await apis.forms.get(params, this.token)
        await this.setInfo(this.token) // 在每次 fetch forms 時額重新取得 info(防止修改組別時 tabs 未正確顯示)
      } catch (e) {
        this.error = e
      }
    },
    refresh () {
      this.forms = null
      this.fetch()
    },
    // 彈出匯出 CSV 視窗
    clickCsv () {
      this.$refs.exportCsv.init()
    },
    // 彈出晉級多個視窗
    clickAdvance () {
      this.$refs.advanceForm.init()
    },
    clickEditForm (id) {
      this.$refs.editForm.show(id)
    },
    // 成功編輯時呼叫: 重新 fetch 並彈出餅乾盒
    successEdit (type) {
      this.isRefetching = true
      this.fetch()
      const messages = {
        remove: '成功移除表單',
        advance: '成功晉級表單',
        newComment: '成功新增評論',
        editComment: '成功修改評論',
        delComment: '成功移除評論',
        advanceMultiple: '成功晉級多個表單',
        manualBill: '成功設定繳費狀態',
      }
      this.$refs.successSnackbar.show(messages[type] || '成功編輯表單')
    },
    // 判斷 equipment 的 key 是否可數
    getIsEquipmentCountable (name) {
      return this.uncountableEquipmentList.every(item => item !== name)
    },
    // 判斷可數的 equipment 項目們是否都 = 0
    getIsCountableEquipmentEmpty (equipment) {
      let count = 0
      for (const key in equipment) { if (this.getIsEquipmentCountable(key) && equipment[key] > 0) count++ }
      return !count
    },
    resetFilter (value = true) {
      this.filter.status.forEach((_, index) => { this.filter.status[index].value = value })
    },
    // 處理網址參數
    handleQuery () {
      const query = this.$route.query
      const tabIndex = this.groupList.findIndex(_ => _ === +query.group)
      const statusIndex = this.filter.status.findIndex(_ => _.key === +query.status)
      const level = this.level
      // 自動切換 tab 至該組別
      if (tabIndex !== -1) {
        this.selectedTab = tabIndex + 1
        this.$refs.snackbar.show(`
          正在查看<b class="primary--text">${this.convertLevelText(level)} › ${this.convertGroupText(query.group)}組</b>
        `)
      }
      // 自動篩選特定狀態表單
      if (statusIndex !== -1) {
        this.resetFilter(false)
        this.filter.status[statusIndex].value = true
        this.$refs.snackbar.show(`
          正在查看<b class="primary--text">${this.convertLevelText(level)} › ${this.convertFormStatusText(query.status)}</b>的表單
        `)
      }
    },
    // 設定篩選結果筆數
    resetSearchAndFilter () {
      this.search = ''
      this.resetFilter()
      this.$router.replace({ query: {} })
    },
    getHeaderText (_) {
      return this.headers.find(i => i.value === _).text
    },
  },
  computed: {
    period () {
      return parseInt(this.$route.params.period)
    },
    level () {
      return parseInt(this.$route.params.level)
    },
    groupList () {
      const info = this.$store.state.formInfo
      try {
        return info ? info[this.period][this.level].groups.sort((a, b) => a - b) : []
      } catch (e) {
        return []
      }
    },
    formGroupId () {
      if (this.selectedTab === 0) return -1
      return this.groupList[this.selectedTab - 1] || null
    },
    isLoading () {
      return this.forms === null || this.isRefetching
    },
    formId () {
      return this.$route.query.formId || null
    },
    filteredForms () {
      return filterForms(this.forms, {
        search: this.search,
        status: this.filter.status,
      })
    },
    isSearching () {
      return this.forms && this.search !== '' && this.search !== null
    },
    isFiltering () {
      return this.forms && !this.filter.status.every(_ => _.value)
    },
    length () {
      return this.filteredForms?.length
    },
    isTablet () {
      return this.$vuetify.breakpoint.sm
    },
    /**
     * WORKAROUND: 這個變數實作不穩定，使用了 Vuetify 未公開暴露的 API，僅供匯出 CSV 使用
     */
    unsafeSortedFilteredForms () {
      // eslint-disable-next-line no-void
      void this.pagination // 必須在此區塊出現這個變數，使得排序欄位變動時強制重新計算

      if (!this.$refs?.table) return []

      const { computedPagination, customSort } = this.$refs.table
      const sortedFilteredForms = customSort(
        this.filteredForms ?? [],
        computedPagination.sortBy,
        computedPagination.descending
      )

      return sortedFilteredForms
    },
  },
  watch: {
    formGroupId () {
      this.forms = null
      this.fetch()
    },
    forms (self) {
      if (self) this.isRefetching = false
    },
    error (self) {
      if (self) this.forms = false
    },
    $route () {
      this.handleQuery()
    },
    'pagination.page' () {
      window.scrollTo(0, 0)
    },
  },
  components: {
    Loader,
    PageTitle,
    EditForm,
    EditComment,
    ExportCsv,
    SnackbarSuccess,
    Snackbar,
    FormBreadcrumb,
    AdvanceForm,
    FormSearch,
    CopyableText,
    PhoneNumberText,
  },
  mixins: [login],
}
</script>

<style scoped lang="sass">
// 設備名稱首字大寫
span.equipment-item
  text-transform: capitalize

// 讓評論遇到 \n 會自動換行
.comment
  white-space: pre-line

.id
  font-family: $monospace

.phone
  span.fragment
    &:not(:last-child)::after
      content: '-'
      color: grey
      letter-spacing: 0

.no-wrap
  white-space: nowrap

.buttons
  white-space: nowrap
</style>
